import { Icon } from "@/components/common/Icon";
import type { DocumentContentBlock } from "@/lib/chat";
import { documentByteLength } from "@/lib/chat-files";
import { formatBytes } from "@/lib/format-bytes";
import type { UploadedFile } from "@/lib/uploaded-file-block";

interface MessageDocumentsProps {
	documents: DocumentContentBlock[];
	uploadedFiles: UploadedFile[];
}

/**
 * メッセージに添付された文書を名前とサイズのチップで並べる。本文に入れた文書とワークスペースへ
 * 置いたファイルは見分けずに同じチップにする。添付がなければ何も描画しない。
 */
export function MessageDocuments({ documents, uploadedFiles }: MessageDocumentsProps) {
	const files = [
		...documents.map((document) => ({
			name: document.title || "文書",
			byteSize: documentByteLength(document),
		})),
		...uploadedFiles,
	];
	if (files.length === 0) return null;

	return (
		<div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 6 }}>
			{files.map((file, idx) => (
				<span
					key={idx}
					data-testid="message-document"
					style={{
						display: "inline-flex",
						alignItems: "center",
						gap: 4,
						padding: "4px 10px",
						maxWidth: "100%",
						fontSize: "var(--text-caption)",
						lineHeight: "var(--leading-none)",
						color: "var(--fg-1)",
						background: "var(--surface-1)",
						borderRadius: "var(--radius-full)",
						boxShadow: "var(--shadow-ring)",
					}}
				>
					<Icon name="file" size={14} color="var(--fg-3)" />
					<span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
						{file.name}
					</span>
					<span style={{ color: "var(--fg-3)", flexShrink: 0 }}>{formatBytes(file.byteSize)}</span>
				</span>
			))}
		</div>
	);
}
